export default __webpack_public_path__ + "assets/c550dc3b3f1656f6551ec06114674a72.jpg";